import { createFileRoute } from '@tanstack/react-router';
import { AgentProfile } from '../../../features/agents/components/AgentProfile';
import { usePageTitle } from '../../../lib/hooks';
import { PageHeader } from '../../../components/layout/PageHeader';

export const Route = createFileRoute('/_auth/agents/$id')({
  component: AgentDetailRoute,
});

function AgentDetailRoute() {
  usePageTitle('Agent Details');
  const { id } = Route.useParams();

  return (
    <div className="flex flex-col gap-6">
      <PageHeader title="Agent Details" backTo="/agents" />
      <AgentProfile agentId={id} />
    </div>
  );
}
